import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './layouts/App'
import reportWebVitals from './reportWebVitals';

// toggle logging
if (process.env.NODE_ENV !== 'production') {
  localStorage.setItem('debug', `${process.env.REACT_APP_LOGGER_NAME}:*`)
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
